import React from "react"
import { HiOutlineArrowSmRight } from "react-icons/hi"
import { useNavigate } from "react-router-dom"

import { ROUTES } from "src/App"

interface StripeConnectionBannerProps {
  eventId?: string
  className?: string
}

const StripeConnectionBanner: React.FC<StripeConnectionBannerProps> = ({
  eventId,
  className = "",
}) => {
  const navigate = useNavigate()

  const handleConnectClick = () => {
    navigate(ROUTES.COMPLETE_PROFILE, {
      state: {
        eventId,
      },
    })
  }

  return (
    <div
      className={`flex w-full items-center mt-4 rounded-2xl overflow-hidden px-5 lg:px-10 py-4 gap-4 bg-white/10 border border-white/20 ${className}`}
    >
      <div className="flex items-center">
        <span className="text-2xl">⛔</span>
      </div>
      <div className="flex flex-col w-full items-start">
        <p className="text-white text-sm text-start">
          Guests can’t buy tickets until you connect your bank account.
        </p>
        <p className="text-white/35 mt-1 text-xs lg:text-base text-start">
          Complete your profile to start selling tickets
        </p>
      </div>
      <div className="flex flex-row">
        <div className="flex">
          <div
            className="h-7 w-7 rounded-lg bg-white/20 border border-white/30 flex items-center justify-center cursor-pointer hover:bg-white/30 transition-colors"
            onClick={handleConnectClick}
          >
            <HiOutlineArrowSmRight className="text-white" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default StripeConnectionBanner
